export const GET_ORDERORIGINS = 'GET_ORDERORIGINS'
export const GET_ORDERORIGINS_EXITO = 'GET_ORDERORIGINS_EXITO'
export const GET_ORDERORIGINS_ERRROR = 'GET_ORDERORIGINS_ERROR'
